import { useOutletContext } from "react-router-dom";
import Container from "@/components/Container";
import LeadForm from "@/components/LeadForm";
import { LogoMark } from "@/components/Logo";

export default function Contact() {
  const { cms } = useOutletContext() || {};
  const c = cms?.contact || {};
  return (
    <div className="pt-36 pb-32">
      <Container className="grid grid-cols-1 lg:grid-cols-12 gap-16 lg:gap-24">
        <div className="lg:col-span-5">
          <div className="flex items-center gap-4 mb-10">
            <span className="label-mono">No. 09 — Contact</span>
            <span className="h-px w-10 bg-ruby" />
          </div>
          <h1 className="serif-display text-5xl md:text-6xl lg:text-[6.5rem] text-ink-700">
            Write to<br />
            <span className="serif-italic text-ruby">the house.</span>
          </h1>
          <p className="mt-10 text-ink-400 leading-[1.8] text-base lg:text-lg max-w-md">
            {c.body || "Every enquiry is read by the team. Properties to offer, partnerships to propose, or trades to engage — write directly to the house."}
          </p>

          <div className="mt-16">
            <LogoMark size={32} className="text-ruby" />
            <p className="label-mono mt-8">By email</p>
            <a
              href={`mailto:${c.email || "info@rubys.group"}`}
              className="mt-4 inline-block serif-light text-3xl lg:text-4xl text-ink-700 hover:text-ruby transition-colors"
              data-testid="contact-email"
            >
              {c.email || "info@rubys.group"} →
            </a>
          </div>
        </div>

        <div className="lg:col-span-7">
          <LeadForm
            leadType="enquiry"
            sourcePage="/contact"
            title="A direct line"
            subtitle="Tell us what brings you to Rubys.Group. We reply within one working day."
            fields={["name","email","phone","message"]}
            submitLabel="Send Message"
          />
        </div>
      </Container>
    </div>
  );
}
